export default ({ $config }, inject) => {
  window.adara = window.adara || function () {
    (window.adara.q = window.adara.q || []).push(arguments)
  }

  window.adara('init', $config.ADARA_ID, $config.ADARA_DPID)
}
